import { useQuery } from '@tanstack/react-query';
import { supabase } from '../lib/supabaseClient';

/** Query-key prefix shared with the realtime handlers' invalidations. */
export const OFFICIAL_ASSIGNMENT_COUNTS_QUERY_KEY_PREFIX = 'official-assignment-counts';

/**
 * Lightweight hook that returns assignment counts per official via RPC.
 * Replaces the 10K match fetch previously used in GameDayFocusView.
 */
export function useOfficialAssignmentCounts(leagueId: string | null | undefined) {
    return useQuery<Map<string, number>>({
        queryKey: [OFFICIAL_ASSIGNMENT_COUNTS_QUERY_KEY_PREFIX, leagueId ?? null],
        queryFn: async () => {
            const { data, error } = await supabase.rpc('get_official_assignment_counts', {
                p_league_id: leagueId || null,
            });

            if (error) throw error;

            const counts = new Map<string, number>();
            if (data) {
                for (const row of data as { official_id: string; assignment_count: number }[]) {
                    counts.set(row.official_id, row.assignment_count);
                }
            }
            return counts;
        },
        staleTime: 60000,
    });
}
